import { Change } from "types";
import { PartialChange } from "types";
import { currentTimeUnixTimestamp } from "helpers";
import {
  deleteCategory,
  deleteItem,
  moveItem,
  moveCategory,
  renameCategory,
  createItem,
  checkUncheckItem,
  markChangeAsSynced,
  updateItem,
} from "redux/slices/checklistSlice";
import { formPostRequest, imageUploadParams } from "helpers";
import { store } from "store";
import { ChangeMutex } from "changes_sync";

declare global {
  interface Window {
    currentUser: { username: string };
  }
}

export async function createChange(partialChange: PartialChange) {
  const state = store.getState();

  const change: Change = {
    ...partialChange,
    id: crypto.randomUUID(),
    author_username: window.currentUser.username,
    // Backend ignores created_at generated by clients.
    // Backend's timeline is the only true timeline.
    // But we need to provide a placeholder value here to satisfy typescript
    created_at: currentTimeUnixTimestamp(),
    checklist_id: state.checklist.value.id,
    suggestion_id: state.suggestion.value.suggestionId,
    synced_to_server: false,
  };

  store.dispatch(generateAction(change));

  if (!change.suggestion_id) {
    // The HTTP call is wrapped in a mutex to: make sure that:
    // 1. all changes are submitted to the backend sequentially
    // 2. this change does not arrive from the backend via action cable before markChangeAsSynced
    ChangeMutex.runExclusive(async () => {
      await formPostRequest(window.location.pathname + "/changes", {
        ...change,
        images: await imageUploadParams(change),
      }).then(() => {
        store.dispatch(markChangeAsSynced(change));
      });
    });
  }
}

export function generateAction(change: Change) {
  switch (change.name) {
    case "deleteCategory":
      return deleteCategory(change);
    case "renameCategory":
      return renameCategory(change);
    case "deleteItem":
      return deleteItem(change);
    case "moveItem":
      return moveItem(change);
    case "moveCategory":
      return moveCategory(change);
    case "createItem":
      return createItem(change);
    case "checkUncheckItem":
      return checkUncheckItem(change);
    case "updateItem":
      return updateItem(change);
  }
}
